import Footer from "../Layout/Footer";
import PayHero from "./PayHero";

const Pay = () => {
  return (
    <>
      <PayHero />
      <Footer />
    </>
  );
};

export default Pay;
